
webpack.register(
    'modules/embed-social/embed-social',
    function() {
        return import('modules/embed-social/embed-social');
    },
    true
);